var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"links"},[_c('router-link',{staticClass:"btn-line btn-rewards_club",attrs:{"to":_vm.word.link}},[_c('div',{class:`btn-line-inner lang-${_vm.lang}`},[_c('div',{staticClass:"copy"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.word.text)}})])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }